/* Solanti Cart Drawer — AJAX cart logic
   Depends on Shopify's built-in Cart AJAX API: /cart/add.js, /cart/change.js, /cart.js
*/
(function () {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  const shippingBar = drawer.querySelector('[data-free-shipping-bar]');
  const shippingCopy = drawer.querySelector('[data-shipping-copy]');
  const shippingFill = drawer.querySelector('[data-shipping-fill]');
  const itemsWrap = drawer.querySelector('[data-cart-items]');
  const totalEl = drawer.querySelector('[data-cart-total]');
  const countEl = drawer.querySelector('[data-cart-count]');
  const threshold = shippingBar ? parseInt(shippingBar.dataset.threshold, 10) : 0; // cents

  // Auto-apply WELCOME10 in the background, once per session, so it's active at checkout.
  // A discount CODE (unlike a Shopify Automatic Discount) doesn't apply itself just by
  // existing — hitting /discount/{code} once sets a cookie Shopify reads at checkout,
  // with no page navigation needed.
  const discountEl = drawer.querySelector('[data-cart-discount]');
  if (discountEl && !sessionStorage.getItem('solanti_discount_applied')) {
    const code = discountEl.dataset.discountCode;
    fetch(`/discount/${code}`, { credentials: 'include' })
      .then(() => sessionStorage.setItem('solanti_discount_applied', 'true'))
      .catch((err) => console.error('Discount apply error:', err));
  }

  function open() {
    drawer.setAttribute('data-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    drawer.removeAttribute('data-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('cart-drawer:open', open);
  document.addEventListener('cart:open', open);
  drawer.querySelectorAll('[data-cart-drawer-close]').forEach((el) => el.addEventListener('click', close));
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-drawer-toggle]')) {
      e.preventDefault();
      open();
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  function formatMoney(cents) {
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: window.Shopify ? window.Shopify.currency.active : 'GBP',
    });
  }

  function updateShippingBar(cartTotal) {
    if (!shippingBar || !threshold) return;
    const remaining = threshold - cartTotal;
    const pct = Math.min(cartTotal / threshold, 1) * 100;
    if (shippingFill) shippingFill.style.width = `${pct}%`;

    if (remaining <= 0) {
      shippingCopy.innerHTML = "You've unlocked <strong>free shipping!</strong>";
    } else {
      shippingCopy.innerHTML = `You're <strong>${formatMoney(remaining)}</strong> away from free shipping!`;
    }
  }

  async function refreshCart() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    if (countEl) countEl.textContent = cart.item_count;
    updateShippingBar(cart.total_price);
    return cart;
  }

  async function changeLine(line, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    return res.json();
  }

  async function addVariant(id, quantity, sellingPlan) {
    const payload = { id, quantity: quantity || 1 };
    if (sellingPlan) payload.selling_plan = sellingPlan;
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    return res.json();
  }

  // Quantity steppers + remove, delegated
  if (itemsWrap) {
    itemsWrap.addEventListener('click', async (e) => {
      const row = e.target.closest('[data-cart-item]');
      if (!row) return;
      const line = parseInt(row.dataset.line, 10);
      const qtyValueEl = row.querySelector('[data-qty-value]');
      let qty = parseInt(qtyValueEl.textContent, 10);

      if (e.target.closest('[data-qty-increase]')) {
        qty += 1;
      } else if (e.target.closest('[data-qty-decrease]')) {
        qty = Math.max(0, qty - 1);
      } else if (e.target.closest('[data-cart-remove]')) {
        qty = 0;
      } else {
        return;
      }

      row.style.opacity = '0.5';
      await changeLine(line, qty);
      if (qty === 0) {
        row.remove();
      } else {
        qtyValueEl.textContent = qty;
        row.style.opacity = '1';
      }
      await refreshCart();
    });
  }

  // Subscription add
  const subscribeBtn = drawer.querySelector('[data-subscribe-add]');
  if (subscribeBtn) {
    subscribeBtn.addEventListener('click', async () => {
      const id = subscribeBtn.dataset.productId;
      const select = drawer.querySelector('[data-selling-plan-select]');
      const sellingPlan = select ? select.value : null;
      subscribeBtn.disabled = true;
      subscribeBtn.textContent = 'Adding…';
      await addVariant(id, 1, sellingPlan);
      await refreshCart();
      window.location.reload(); // simplest way to reflow line items after add; swap for a section re-render if you want no reload
    });
  }

  // Quick add cross-sell items
  drawer.querySelectorAll('[data-quick-add]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const id = btn.dataset.variantId;
      btn.disabled = true;
      btn.textContent = 'Added';
      await addVariant(id, 1);
      await refreshCart();
      window.location.reload();
    });
  });

  // Init on load
  refreshCart();
})();